export default "__VITE_ASSET__DOWBTn07__"